export default __webpack_public_path__ + "static/media/Group8890.0d7a3f20.svg";